import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref, computed } from "vue";
import DeviceModule from "@/store/modules/device";
export default defineComponent({
  name: "DeviceLocationSettings",
  components: {},
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var deviceId, hasHardwareLocation, hardwareLocation, devices;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              deviceId = ref(DeviceModule.deviceId || null); // DeviceModule.fetchDevices();

              hasHardwareLocation = computed(function () {
                if (DeviceModule.hardwareLocation) {
                  return true;
                } else {
                  // we fetch devices from backend and set them to the state and return false
                  return false;
                }
              });

              if (hasHardwareLocation.value) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return DeviceModule.fetchDevices();

            case 5:
              hardwareLocation = computed(function () {
                return DeviceModule.hardwareLocation;
              });
              devices = computed(function () {
                return DeviceModule.getDevices;
              });
              return _context.abrupt("return", {
                hasHardwareLocation: hasHardwareLocation,
                deviceId: deviceId,
                hardwareLocation: hardwareLocation,
                devices: devices
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
});